import $ from 'jquery';
import { Wireup, ListView } from 'rustig';
import "./views/facilities/encounters/documents";
import { ClearInputs } from "./util/clearinputs";

declare global {
  interface Window {
    Rustig: any;
  }
}

$(function () {
  var app = new Wireup();

  app.execute()

  ClearInputs.Wireup();
  window.Rustig.ListView = ListView;
});
